import React from "react";
import Typewriter from "typewriter-effect";

function Type() {
  return (
    <Typewriter
      options={{
        strings: [
          "Dreamer",
          "Learner",
          "Planner",
          "Developer",
          "QA",
          "Scrum & DevOps Practitioner",
          "Open Source Supporter",
        ],
        autoStart: true,
        loop: true,
        deleteSpeed: 50,
      }}
    />
  );
}

export default Type;
